<template>
    <transition appear name="slide-left">
        <div class="notes" :class="{'show-timeline' : showTimeline && items}">
            <h1 v-if="showTitle">{{title}}</h1>
            <template v-if="items">
                <transition-group
                    appear
                    @enter='enter'
                    @before-enter='beforeEnter'
                    @leave='leave' 
                    tag="span"
                >
                    <div
                        v-for="(item, index) in items"
                        :data-index="index"
                        :key="index"
                    >
                       <stb-card
                           :icon="item.icon" 
                           :title="item.title"
                           :subtitle="item.subtitle"
                           @click.native="item_click(item, index)"
                        >
                        <template slot="meta">
                            {{item.meta}}
                        </template>
                        {{item.description}}
                       </stb-card>
                    </div>
                </transition-group>
            </template>
            <!--
            <div>
                <div class="nameCard">
                    <div>
                        <a class="ellipsis">Hinzugefügt: 12.06.18 - 12.00 Uhr</a>
                        <div>
                            <img src="@/assets/images/targetIcon.svg"></img>
                            <h5>12km</h5>
                        </div>
                    </div>
                    <div class="nameCardProfile">
                        <div>
                            <img src="@/assets/images/profileDark.svg"></img>
                            <div>
                                <h4 class="ellipsis">Ignaz Unterbacher</h4>
                                <a>max.mustermann@t-onlline.de</a>
                            </div>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor in</p>
                    </div>
                </div>
            </div>
            <div>
                <div class="nameCard">
                    <div>
                        <a class="ellipsis">Hinzugefügt: 12.06.18 - 12.00 Uhr</a>
                        <div>
                            <img src="@/assets/images/targetIcon.svg"></img>
                            <h5>12km</h5>
                        </div>
                    </div>
                    <div class="nameCardProfile">
                        <div>
                            <img src="@/assets/images/profileDark.svg"></img>
                            <div>
                                <h4 class="ellipsis">Ignaz Unterbacher</h4>
                                <a>max.mustermann@t-onlline.de</a>
                            </div>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor in</p>
                    </div>
                </div>
            </div>
            <div>
                <div class="nameCard">
                    <div>
                        <a class="ellipsis">Hinzugefügt: 12.06.18 - 12.00 Uhr</a>
                        <div>
                            <img src="@/assets/images/targetIcon.svg"></img>
                            <h5>12km</h5>
                        </div>
                    </div>
                    <div class="nameCardProfile">
                        <div>
                            <img src="@/assets/images/profileDark.svg"></img>
                            <div>
                                <h4 class="ellipsis">Ignaz Unterbacher</h4>
                                <a>max.mustermann@t-onlline.de</a>
                            </div>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor in</p>
                    </div>
                </div>
            </div>
            -->
        </div>
    </transition>
</template>

<style>
.nameCardProfile {
    cursor: pointer;
}

.notes {
    position: relative;
}

</style>

<script>
export default {
    props: {
        'title': {},
        'items': {},
        'showTimeline': {
            default: false
        },
        'showTitle': {
            default: true,
        },
    },
    methods: {
        item_click(item, index) {
            this.$emit('item-click', item, index);
        },

        beforeEnter: function(el) {
            $j(el)
                .removeClass("note-in-leave")
                .addClass("note-in-enter")
                .addClass("note-in-enter-active");
        },
        enter: function (el, done) {
          var delay = el.dataset.index * 150;
          setTimeout(function () {
            $j(el).removeClass("note-in-enter");
            done();
          }, delay)
        },
        leave: function(el, done) {
            $j(el).addClass("note-in-leave");
            setTimeout(() => {
                done();
            }, 750);
            console.log('Asd')
        },

    },
}
</script>



// WEBPACK FOOTER //
// src/components/notifications.vue